// ✅ Selectors
export const selectAddAssignmentsData = (state) => state?.assignments?.addAssignments?.data;
export const selectAddAssignmentsLoading = (state) => state?.assignments?.addAssignments?.loading;
export const selectAddAssignmentsError = (state) => state?.assignments?.addAssignments?.error;

export const selectUpdateAssignmentsData = (state) => state?.assignments?.updateAssignments?.data;
export const selectUpdateAssignmentsLoading = (state) => state?.assignments?.updateAssignments?.loading;
export const selectUpdateAssignmentsError = (state) => state?.assignments?.updateAssignments?.error;

// New Archive Selectors
export const selectArchiveAssignmentsData = (state) => state?.assignments?.archiveAssignments?.data;
export const selectArchiveAssignmentsLoading = (state) => state?.assignments?.archiveAssignments?.loading;
export const selectArchiveAssignmentsError = (state) => state?.assignments?.archiveAssignments?.error;

export const selectAssignmentsList = (state) => state?.assignments?.getAssignmentsList?.data || [];
export const selectAssignmentsListLoading = (state) => state?.assignments?.getAssignmentsList?.loading;
export const selectAssignmentsListError = (state) => state?.assignments?.getAssignmentsList?.error;
export const selectAssignmentsListTotal = (state) => state?.assignments?.getAssignmentsList?.total || 0;

export const selectAssignmentsDetail = (state) => state?.assignments?.getAssignmentsDetail?.data;
export const selectAssignmentsDetailLoading = (state) => state?.assignments?.getAssignmentsDetail?.loading;
export const selectAssignmentsDetailError = (state) => state?.assignments?.getAssignmentsDetail?.error;

export const selectDeleteAssignmentsData = (state) => state?.assignments?.deleteAssignments?.data;
export const selectDeleteAssignmentsLoading = (state) => state?.assignments?.deleteAssignments?.loading;
export const selectDeleteAssignmentsError = (state) => state?.assignments?.deleteAssignments?.error;

export const selectAssignmentsState = (state) => state?.assignments;

